import api from "./api";
import { ApiResponse, Tema, TemaCreateDTO, TemaUpdateDTO } from "./types";

export const TemaService = {
  listele: async () => {
    const response = await api.get<ApiResponse<Tema[]>>("/api/Tema/Listele");
    return response.data;
  },

  detay: async (id: string) => {
    const response = await api.get<ApiResponse<Tema>>(`/api/Tema/Detay/${id}`);
    return response.data;
  },

  ekle: async (data: TemaCreateDTO) => {
    const formData = new FormData();
    formData.append("baslik", data.baslik);
    formData.append("aciklama", data.aciklama);
    formData.append("sira", data.sira.toString());

    if (data.yatayGorselForm) {
      formData.append("yatayGorselForm", data.yatayGorselForm);
    }
    if (data.kapakGorselForm) {
      formData.append("kapakGorselForm", data.kapakGorselForm);
    }
    if (data.detayGorselForm) {
      formData.append("detayGorselForm", data.detayGorselForm);
    }

    const response = await api.post<ApiResponse<Tema>>(
      "/api/Tema/Ekle",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },

  guncelle: async (data: TemaUpdateDTO) => {
    const formData = new FormData();
    formData.append("id", data.id);
    formData.append("baslik", data.baslik);
    formData.append("aciklama", data.aciklama);
    formData.append("sira", data.sira.toString());
    formData.append("yatayGorsel", data.yatayGorsel || "");
    formData.append("kapakGorsel", data.kapakGorsel || "");
    formData.append("detayGorsel", data.detayGorsel || "");

    if (data.yatayGorselForm) {
      formData.append("yatayGorselForm", data.yatayGorselForm);
    }
    if (data.kapakGorselForm) {
      formData.append("kapakGorselForm", data.kapakGorselForm);
    }
    if (data.detayGorselForm) {
      formData.append("detayGorselForm", data.detayGorselForm);
    }

    const response = await api.put<ApiResponse<Tema>>(
      "/api/Tema/Guncelle",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },

  sil: async (id: string) => {
    const response = await api.delete<ApiResponse<boolean>>(
      `/api/Tema/Sil/${id}`
    );
    return response.data;
  },
};
